import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiCommonService } from '@api-services/api-common.service';
import { API_ROUTE_BASE } from '@constants/api-routes.constant';
import { ApiAlertError } from '@decorators/api-alert-error';
import { Permission, PermissionJson } from '@models/permission';

/**
 * Permission Api Service.
 */
@Injectable({
  providedIn: 'root'
})
export class PermissionApiService extends ApiCommonService<Permission> {
  resourceUrl = `${API_ROUTE_BASE}`;

  @ApiAlertError()
  getCompanyPermission(companyId: number): Observable<Permission> {
    const url = `${this.resourceUrl}/companies/${companyId}/users/me/permissions`;

    return this.http.get(url, { observe: 'response' }).pipe(
      map((response: HttpResponse<PermissionJson>) => {
        if (response.status === 204) {
          return null;
        } else {
          return Permission.fromJson(response.body);
        }
      })
    );
  }

  fromJson(json: Partial<PermissionJson>): Permission {
    return Permission.fromJson(json);
  }

  toJson(model: Permission): Partial<PermissionJson> {
    throw new Error('Unusable');
  }
}
